// Save password in localStorage (for 1-day event, acceptable)
export const login = (password) => {
  if (password === 'Athleon2025!') { // ← same as backend
    localStorage.setItem('athleon_admin', 'true');
    return true;
  }
  return false;
};

export const isAdmin = () => localStorage.getItem('athleon_admin') === 'true';

export const logout = () => localStorage.removeItem('athleon_admin');


export const SUPER_ADMIN_PASSWORD = 'SuperAthleon2025!'; // ← Change this!

export const isSuperAdmin = () => localStorage.getItem('athleon_super_admin') === 'true';

export const loginSuperAdmin = (password) => {
  if (password === SUPER_ADMIN_PASSWORD) {
    localStorage.setItem('athleon_super_admin', 'true');
    return true;
  }
  return false;
};

export const logoutSuperAdmin = () => localStorage.removeItem('athleon_super_admin');